/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconBackpack = createSolidComponent("backpack", "IconBackpack", [
  [
    "path",
    {
      d: "M5 18v-6a6 6 0 0 1 6 -6h2a6 6 0 0 1 6 6v6a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3z"
    }
  ],
  ["path", { d: "M10 6v-1a2 2 0 1 1 4 0v1" }],
  ["path", { d: "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4" }],
  ["path", { d: "M11 10h2" }]
]);

export { IconBackpack as default };
//# sourceMappingURL=IconBackpack.js.map
